module.exports = __webpack_public_path__ + "static/media/aquafury-1.e3e19575.jpg";